import { needsGuidePhotoConversion, prepareGuidePhotoFile } from "../../../utils/guidePhotoFile";

// Existing attachment IDs must survive an edit so the API retains those files.
export const uploadGuidePhotos = async (photos, uploadFile, genUUID, uploaded = new Map()) => {
  const attachments = [];
  for (const photo of photos) {
    const { file, ...attachment } = photo;
    if (file) {
      const uploadFileData = needsGuidePhotoConversion(file) ? await prepareGuidePhotoFile(file) : file;
      const upload = uploaded.get(uploadFileData) || uploadFile(
        uploadFileData, `welcome_guide/attachments/${genUUID()}`
      );
      // Share pending uploads too, so cancelling analysis then saving does
      // not upload the same file twice.
      uploaded.set(uploadFileData, upload);
      let url;
      try {
        url = await upload;
        if (!url) throw new Error(`Could not upload ${file.name}`);
        uploaded.set(uploadFileData, url);
      } catch (error) {
        if (uploaded.get(uploadFileData) === upload) uploaded.delete(uploadFileData);
        throw error;
      }
      attachments.push({ ...attachment, ...(uploadFileData !== file ? {
        name: uploadFileData.name, original_name: uploadFileData.name,
      } : {}), url });
    } else if (attachment.url) {
      attachments.push(attachment);
    }
  }
  return attachments;
};

export const getUneditedGuideAttachments = (attachments = []) => {
  if (attachments === null) return [];
  const firstFile = attachments.find((a) => a.type === "file");
  const firstVideo = attachments.find((a) => a.type === "you_tube");
  return attachments.filter(
    (a) => a.type !== "image" && a !== firstFile && a !== firstVideo
  );
};
